import { LAYER, LAYER_PROPS } from 'constants/Constants';
import Layer from 'ol/layer/Layer';
import { mapStore } from 'stores/Map';
import { SystemStore } from "stores/System";
import { useKamcoTextLabels } from './useKamcoTextLabels';

export const useMapLayerManagement = () => {
    const { map } = mapStore();
    const { isKamcoDemo } = SystemStore();
    const { updateTextLayerVisible, clearTextLayers } = useKamcoTextLabels();

    const findLayer = (propName: string, value: any) => {
        const layers = map?.getAllLayers();
        return layers?.find((layer) => layer.get(propName) === value);
    }

    const findLayers = (propName: string, value: any) => {
        const layers = map?.getAllLayers();
        return layers?.filter((layer => layer.get(propName) === value));
    }

    const findResultLayer = () => {
        return findLayers(LAYER_PROPS.LAYER_TYPE, LAYER.RESULT_LAYER);
    }

    const findCustomLayer = () => {
        return findLayers(LAYER_PROPS.LAYER_TYPE, LAYER.CUSTOM_LAYER);
    }

    const findKamcoCustomLayer = () => {
        return findLayers(LAYER_PROPS.LAYER_TYPE, LAYER.KAMCO_CUSTOM_LAYER);
    }

    const clearLayers = (layers: Layer[]) => {
        layers.forEach((layer) => {
            (layer.getSource() as any).clear();
            layer.dispose();
            map?.removeLayer(layer);
        })
    }

    //layer name별 Visible 세팅
    const updateLayerVisibleByName = (layerName: string, is: boolean) => {
        const layers = findLayers(LAYER_PROPS.LAYER_NAME, layerName);
        layers?.forEach((layer) => {
            layer.setVisible(is);
        });
        
        // KAMCO 텍스트 레이어도 함께 visible 조절
        if (isKamcoDemo) {
            updateTextLayerVisible(layerName, is);
        }
    }

    // KAMCO 6차 데이터 레이어 visible 조절
    const updateKamcoCustomLayerVisible = (is: boolean) => {
        const layers = findKamcoCustomLayer();
        layers?.forEach((layer) => {
            layer.setVisible(is);
        });
        
        // 6차 데이터 텍스트 레이어도 함께 visible 조절
        if (isKamcoDemo) {
            layers?.forEach((layer) => {
                const layerName = layer.get(LAYER_PROPS.LAYER_NAME);
                if (layerName) {
                    updateTextLayerVisible(layerName, is);
                }
            });
        }
    }

    // KAMCO 6차 데이터 레이어 opacity 조절
    const updateKamcoCustomLayerOpacity = (opacity: number) => {
        const layers = findKamcoCustomLayer();
        layers?.forEach((layer) => {
            layer.setOpacity(opacity);
        });
    }

    //layer 전체 Opacity
    const updateLayerOpacity = (opacity: number) => {
        const layers = findResultLayer();
        layers?.forEach((layer) => {
            layer.setOpacity(opacity);
        });
    };

    //layer 전체 Visible
    const updateLayerVisible = (is: boolean, isCustom: boolean) => {
        const layers = isCustom ? findCustomLayer() : findResultLayer();
        layers?.forEach((layer) => {
            layer.setVisible(is);
        });
    };

    return {
        findLayer,
        findLayers,
        findResultLayer,
        findCustomLayer,
        findKamcoCustomLayer,
        clearLayers,
        updateLayerVisibleByName,
        updateLayerOpacity,
        updateLayerVisible,
        updateKamcoCustomLayerVisible,
        updateKamcoCustomLayerOpacity,
        clearTextLayers
    };
};
